// Uploaded logos and photos are re-encoded by a background job; poll until it settles.
// settlement_pending is not terminal (workPollingDelay keeps polling it).
import { workPollingDelay } from '@shared/utils/workBilling';
import { get, uploadForm } from '../api';

export async function waitForImage(image, onUpdate, timeoutMs) {
  const deadline = Date.now() + (timeoutMs || 120000);
  let current = image;
  while (current && Date.now() < deadline) {
    const delay = workPollingDelay(current);
    if (delay === null) return current;
    await new Promise(resolve => window.setTimeout(resolve, delay));
    current = await get('/images/' + current.id);
    if (onUpdate) onUpdate(current);
  }
  return current;
}

export async function uploadImage(path, file, fields) {
  const body = new FormData();
  Object.keys(fields || {}).forEach(key => body.append(key, String(fields[key])));
  body.append('file', file);
  return uploadForm(path, body);
}
